@let validPercent = screeningSummaryData().validPercent;
@let isAllValid = screeningSummaryData().isAllValid;
@let maybeValidXofY = screeningSummaryData().maybeValidXofY;
@let screeningStatus = screeningSummaryData().screeningStatus;

<div class="status">
  @if (screeningStatus === 'failed') {
    <rt-icon name="help-filled" colorToken="colorIconLowDisabled" size="medium" />
    <span text-weight-default>
      {{ 'app.ai_candidate_screening.results.unknown' | translate }}
    </span>
  } @else if (screeningStatus === 'pending' || screeningStatus === 'in_progress') {
    <rt-icon name="ai" />
    <span text-weight-default>
      {{ 'app.ai_candidate_screening.results.screening' | translate }}
    </span>
  } @else if (screeningStatus === 'completed') {
    <rt-screening-icon [fillAmount]="validPercent" />
    <span [class.valid]="isAllValid">
      {{ maybeValidXofY }}
    </span>
  }
</div>
